"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ZIndexType;
(function (ZIndexType) {
    ZIndexType["Hard"] = "hard";
    ZIndexType["YSort"] = "y-sort";
})(ZIndexType || (ZIndexType = {}));
exports.default = ZIndexType;
